import React from "react";
import "../../ModalLinkCreation/Blocks/ThumbnailPicker/Thumbnail.scss";

const ClassicLargeThumbnailPrev = ({ link }) => {
  return (
    <a href={link.LinkUrl} target="_blank" rel="noopener noreferrer">
      <div className="classic-large-thumbnail-prev">
        <div className="img">
          <img src={link.LinkImage} alt="img thumbnail" />
        </div>
        <div className="title-thumbnail">{link.LinkTitle}</div>
      </div>
    </a>
  );
};

export default ClassicLargeThumbnailPrev;
